import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X, Send, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = `Quick Contact from ${formData.name}`;
    const body = `Name: ${formData.name}
Email: ${formData.email}

Message:
${formData.message}`;
    window.location.href = `mailto:parker@plastices.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        message: ''
      });
      setIsOpen(false);
    }, 3000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };
  return <>
      {/* Floating Button */}
      <motion.button onClick={() => setIsOpen(!isOpen)} className="fixed bottom-6 right-6 z-50 bg-accent hover:bg-accent-hover text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} aria-label="Open chat" data-id="element-56">
        <AnimatePresence mode="wait" data-id="element-57">
          {isOpen ? <motion.div key="close" initial={{
          rotate: -90,
          opacity: 0
        }} animate={{
          rotate: 0,
          opacity: 1
        }} exit={{
          rotate: 90,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-58">
              <X className="h-6 w-6" data-id="element-59" />
            </motion.div> : <motion.div key="open" initial={{
          rotate: 90,
          opacity: 0
        }} animate={{
          rotate: 0,
          opacity: 1
        }} exit={{
          rotate: -90,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-60">
              <MessageCircle className="h-6 w-6" data-id="element-61" />
            </motion.div>}
        </AnimatePresence>
      </motion.button>

      {/* Chat Widget */}
      <AnimatePresence data-id="element-62">
        {isOpen && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/20 z-40 md:hidden" onClick={() => setIsOpen(false)} data-id="element-63" />

            {/* Chat Card */}
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="fixed bottom-24 right-6 z-50 w-[calc(100vw-3rem)] md:w-96 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden" data-id="element-64">
              {/* Header */}
              <div className="bg-gradient-to-r from-primary to-primary-dark text-white p-4" data-id="element-65">
                <h3 className="font-bold text-lg" data-id="element-66">Quick Contact</h3>
                <p className="text-sm text-blue-100" data-id="element-67">
                  We'll get back to you soon
                </p>
              </div>

              {/* Content */}
              <div className="p-4" data-id="element-68">
                {submitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="py-8 text-center" data-id="element-69">
                    <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-3" data-id="element-70" />
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-71">
                      Message Sent!
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-72">
                      Your email client should open shortly.
                    </p>
                  </motion.div> : <form onSubmit={handleSubmit} className="space-y-3" data-id="element-73">
                    <div data-id="element-74">
                      <label htmlFor="name" className="text-xs font-medium text-gray-700 block mb-1" data-id="element-75">
                        Name
                      </label>
                      <input type="text" id="name" value={formData.name} onChange={handleChange} className="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all" placeholder="Your name" required data-id="element-76" />
                    </div>

                    <div data-id="element-77">
                      <label htmlFor="email" className="text-xs font-medium text-gray-700 block mb-1" data-id="element-78">
                        Email
                      </label>
                      <input type="email" id="email" value={formData.email} onChange={handleChange} className="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all" placeholder="your@email.com" required data-id="element-79" />
                    </div>

                    <div data-id="element-80">
                      <label htmlFor="message" className="text-xs font-medium text-gray-700 block mb-1" data-id="element-81">
                        Message
                      </label>
                      <textarea id="message" rows={3} value={formData.message} onChange={handleChange} className="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all resize-none" placeholder="How can we help?" required data-id="element-82"></textarea>
                    </div>

                    <Button type="submit" className="w-full" size="md" rightIcon={<Send className="h-4 w-4" data-id="element-84" />} data-id="element-83">
                      Send Message
                    </Button>

                    <p className="text-xs text-center text-gray-500" data-id="element-85">
                      Or call us at{' '}
                      <a href="tel:+18016186677" className="text-primary hover:text-accent" data-id="element-86">
                        (801) 618-6677
                      </a>
                    </p>
                  </form>}
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}